<template>
  <NuxtLoadingIndicator color="#be4044" :height="5" />
  <MainMenu />
  <NuxtPage />
  <ClientOnly>
    <UiScoll2TopBtn />
    <UiTelegram />
    <UiCookieAccept
      v-if="data?.policy"
      :js="data?.settings?.footer_js"
      :policy="data?.policy"
      :value="cookieAccept"
    />
  </ClientOnly>
</template>

<script setup>
const cookieAccept = useCookie("cookieAccept");
import { provide } from "vue";
const { data, error } = await useFetch("/api/start");
provide("contacts", data?.value?.contacts);
provide("formOptions", data?.value?.formOptions);
provide("social", data?.value?.social);
provide("yaMap", data?.value?.yaMap);
provide("achievements", data?.value?.achievements);
//provide('settings', data?.value?.settings);

//https://nuxt.com/modules/device
//https://nuxt.com/docs/getting-started/seo-meta
const { isMobileOrTablet } = useDevice();
const head = {
  bodyAttrs: {
    class: isMobileOrTablet ? "_is_mobile" : "",
  },
};
if (data?.value.settings?.ywm)
  head.meta = [
    { name: "yandex-verification", content: data.value.settings.ywm },
  ];
useHead(head);

if (data?.value.settings?.metrika)
  useState("metrika").value = data.value.settings.metrika;
</script>
